import { useQuery } from '@tanstack/react-query'
import { type ContactDetails, contactDetailsSchema, ContactDetailsApiPath } from '@mobi/api-types'
import { queryKeys } from '../Utils'
import { get } from '../Utils/network'

const enum LocalConstants {
  TTL = 1000 * 60 * 60 * 8, // 8 hours
}

export const useUserContactDetails = (betAccountNumber: number) => {
  return useQuery({
    queryKey: [queryKeys.accountUserContactDetails, betAccountNumber],
    queryFn,
    staleTime: LocalConstants.TTL,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  })
}

const queryFn = async () => {
  const parser = contactDetailsSchema.parse
  return await get<ContactDetails>(ContactDetailsApiPath, parser)
}
